import { Category, ICategoryDataV3 } from '@df/catalog/category/category';

Category.onLoad((category: Category) => {
    if (category.hasV3) {
        const data = category.data as ICategoryDataV3;
        const products = data.products;
        if (data.pageTemplate && data.pageTemplate === 'giftcards' && products && products.length) {
            return new Promise<void>(resolve => category.resources.product.loadAllIds(products, 3, { safe: true }).finally(resolve));
        }
    }
    return undefined;
});
